// @flow

/**
 * Module dependencies.
 */

import { asset } from 'core/utils';
import { compose, defaultProps } from 'recompose';
import { prop } from 'styled-tools';
import React from 'react';
import styled from 'styled-components';

/**
 * `Props` type.
 */

type Props = {
  baseWidth?: number,
  extension: string,
  filename: string,
  maxWidth?: string,
  styles?: string,
  title?: string
};

/**
 * `Image` styled component.
 */

const Image = styled.img`
  display: inline-block;
  height: auto;
  max-width: ${prop('maxWidth', '100%')};
  ${prop('styles', '')};
`;

/**
 * Get `srcset` size.
 */

const getSize = (baseWidth?: number): Function => (dpi: number): string => {
  return isNaN(baseWidth) ? `${dpi}x` : `${Number(baseWidth) * dpi}w`;
};

/**
 * `RetinaImageComponent` component.
 */

function RetinaImageComponent(props: Props): React$Element<*> {
  const { baseWidth, extension, filename, styles, title, ...rest } = props;
  const defaultImageUrl = asset(require(`client/assets/images/${filename}.${extension}`));
  const retinaImageUrl = asset(require(`client/assets/images/${filename}@2x.${extension}`));
  const setSize = getSize(baseWidth);

  return (
    <Image
      {...rest}
      alt={title}
      src={defaultImageUrl}
      srcSet={`${defaultImageUrl} ${setSize(1)}, ${retinaImageUrl} ${setSize(2)}`}
      styles={styles}
    />
  );
}

/**
 * Export `RetinaImageComponent`.
 */

export default compose(
  defaultProps({
    extension: 'jpg'
  })
)(RetinaImageComponent);



// WEBPACK FOOTER //
// ../src/client/components/core/images/retina-image.js